import * as React from 'react'

const ServiceDefaultLogo = (props: any) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='96'
      height='96'
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='48' cy='48' r='47.5' fill='#D5D5D5' stroke='#D5D5D5' />
      <rect x='25' y='25' width='20' height='20' stroke='white' strokeWidth='2' />
      <rect x='31.0996' y='31.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='37.7012' y='31.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='37.7012' y='37.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='31.0996' y='37.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='51' y='25' width='20' height='20' stroke='white' strokeWidth='2' />
      <rect x='57.0996' y='31.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='63.7012' y='31.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='63.7012' y='37.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='57.0996' y='37.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='25' y='51' width='20' height='20' stroke='white' strokeWidth='2' />
      <rect x='31.0996' y='57.1006' width='1.2' height='1.2' fill='#666666' stroke='white' />
      <rect x='37.7012' y='57.1006' width='1.2' height='1.2' fill='#666666' stroke='white' />
      <rect x='37.7012' y='63.7002' width='1.2' height='1.2' fill='#666666' stroke='white' />
      <rect x='31.0996' y='63.7002' width='1.2' height='1.2' fill='#666666' stroke='white' />
      <rect x='51' y='51' width='20' height='20' stroke='white' strokeWidth='2' />
      <rect x='57.0996' y='57.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='63.7012' y='57.1006' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='63.7012' y='63.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
      <rect x='57.0996' y='63.7002' width='1.2' height='1.2' fill='#405264' stroke='white' />
    </svg>
  )
}

export default ServiceDefaultLogo



// WEBPACK FOOTER //
// ./src/components/icons/ui/ServiceDefaultLogo.tsx